(() => {
  if (customElements.get('ss-polish-set')) return;
  class SSPolishSet extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.priceObserver?.observe(this.querySelector('[data-price-sources]'), {childList:true, subtree:true, characterData:true}); this.update(); return; }
      const source = this.querySelector('[data-set-data]');
      if (!source) return;
      this.ready = true;
      this.data = JSON.parse(source.textContent);
      this.form = this.querySelector('[data-set-form]');
      this.button = this.form.querySelector('button[type="submit"]');
      this.status = this.querySelector('[data-set-status]');
      this.buttonLabel = this.button.querySelector('[data-set-button-label]');
      this.money = new Intl.NumberFormat(this.data.locale, {style:'currency', currency:this.data.currency});
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('input', event => { if (event.target.name === 'quantity') this.update(); });
      this.form.addEventListener('submit', event => this.submit(event));
      this.priceObserver = new MutationObserver(() => { if (!this.busy) this.update(); });
      this.priceObserver.observe(this.querySelector('[data-price-sources]'), {childList:true, subtree:true, characterData:true});
      this.update();
    }
    disconnectedCallback() { this.priceObserver?.disconnect(); }
    format(cents) { return this.money.format(cents / 100); }
    price(variant) {
      const text = this.querySelector(`[data-source-id="${variant.id}"]`)?.textContent?.trim();
      if (!text) return variant.price;
      // Shopify money formatting can differ from the storefront language.
      const digits = text.replace(/[^0-9.,-]/g, '');
      const fractionDigits = this.money.resolvedOptions().maximumFractionDigits;
      const decimal = fractionDigits && digits.match(new RegExp('[.,](\\d{' + fractionDigits + '})$'));
      const normalized = decimal ? digits.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1] : digits.replace(/[.,]/g, '');
      const amount = Number(normalized);
      return normalized && Number.isFinite(amount) ? Math.round(amount * 100) : variant.price;
    }
    state() {
      const values = new FormData(this.form);
      const volume = values.get('volume');
      const withPads = values.get('pads') === 'with';
      const size = values.get('pad_size');
      const quantity = Math.max(1, Math.min(99, Math.floor(Number(values.get('quantity')) || 1)));
      const bottles = this.data.products.slice(0,3).map((p,i) => p.variants.find(v => v.id === this.data.bottleIds[volume]?.[i]));
      const padBundle = this.data.padBundles[volume === '1000' ? '9' : '3'];
      const pads = withPads && size ? [padBundle?.variants.find(v => v.id === this.data.padBundleIds[volume === '1000' ? '9' : '3'][size])] : [];
      const polishBundle = volume === '250' ? this.data.base : this.data.litreBase;
      const selected = [polishBundle, ...pads];
      const padIds = volume === '1000' ? this.data.padPackIds : this.data.padIds;
      const padComponents = withPads && size ? this.data.products.slice(3).map((p,i) => p.variants.find(v => v.id === padIds[size]?.[i])) : [];
      const componentTotal = [...bottles, ...padComponents].filter(Boolean).reduce((sum,v) => sum + v.price, 0);
      const bundleReference = selected.filter(Boolean).reduce((sum,v) => sum + Math.max(v.price, v.compareAtPrice || 0), 0);
      const reference = Math.max(componentTotal, bundleReference);
      const valid = selected.every(v => v && v.available);
      return {volume, withPads, size, quantity, bottles, pads, selected, valid, reference};
    }
    update() {
      if (!this.busy) this.form.querySelectorAll('fieldset,input[name="quantity"]').forEach(el => el.disabled = false);
      const s = this.busy && this.current ? this.current : this.state();
      this.current = s;
      this.querySelector('[data-pad-details]').hidden = !s.withPads;
      this.form.querySelectorAll('[name="pad_size"]').forEach(input => input.required = s.withPads);
      const missingSize = s.withPads && !s.size;
      const litre = s.volume === '1000';
      this.querySelector('[data-pad-option-label]').textContent = litre ? this.data.ui.with_nine_pads : this.data.ui.with_pads;
      this.querySelector('[data-pad-option-subtitle]').textContent = litre ? this.data.ui.pad_subtitle_nine : this.data.ui.pad_subtitle;
      this.querySelectorAll('[data-pad-count]').forEach(el => el.textContent = litre ? this.data.ui.three_each : this.data.ui.one_each);
      this.querySelector('[data-litre-notice]').hidden = !litre;
      const price = s.selected.filter(Boolean).reduce((sum, v) => sum + this.price(v), 0) * s.quantity;
      this.querySelector('[data-set-price]').textContent = this.format(price);
      const original = s.reference * s.quantity;
      const reduced = !missingSize && original > price;
      const compare = this.querySelector('[data-set-compare]');
      compare.hidden = !reduced;
      compare.querySelector('[data-set-compare-amount]').textContent = reduced ? this.format(original) : '';
      const saving = this.querySelector('[data-set-saving]');
      saving.hidden = !reduced;
      saving.textContent = reduced ? this.data.ui.saving.replace('__AMOUNT__', this.format(original - price)) : '';
      this.querySelector('[data-price-note]').textContent = this.data.ui.total;
      const padTotal = s.pads.filter(Boolean).reduce((sum, v) => sum + this.price(v), 0);
      this.querySelector('[data-pad-price]').textContent = s.pads.length ? this.data.ui.pad_addition.replace('__AMOUNT__',this.format(padTotal)) : this.data.ui.choose_size;
      let selection = this.data.ui.selection.replace('__VOLUME__',s.volume === '250' ? '250 ml' : '1 l');
      if (s.withPads) selection += ' · ' + (litre ? this.data.ui.selection_nine_pads : this.data.ui.selection_pads).replace('__SIZE__', s.size ? `${s.size} mm` : '…');
      this.querySelector('[data-selection]').textContent = selection;
      this.button.disabled = this.busy || missingSize || !s.valid;
      this.buttonLabel.textContent = missingSize ? this.data.ui.choose_size : !s.valid ? this.data.ui.unavailable : this.data.ui.add;
      this.form.querySelectorAll('fieldset,input[name="quantity"]').forEach(el => el.disabled = !!this.busy);
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const s = this.state();
      if (!s.valid || s.withPads && !s.size) return;
      this.busy = true;
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      this.button.setAttribute('aria-busy','true');
      this.update();
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
      let confirmed = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:s.selected.map(v => ({id:v.id,quantity:s.quantity})),sections:[...new Set(sections)].slice(0,5),sections_url:window.location.pathname})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.data.ui.error);
        confirmed = true;
        this.status.textContent = this.data.ui.added;
        if (window.themeVariables?.settings?.cartType === 'page') { window.location.assign(`${root}cart`); return; }
        const cartResponse = await fetch(`${root}cart.js`,{headers:{'Accept':'application/json'}});
        if (!cartResponse.ok) throw new Error(this.data.ui.error);
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        this.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items || [result],cart}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
      } catch (error) {
        if (confirmed) { document.dispatchEvent(new CustomEvent('cart:refresh')); }
        else { this.status.textContent = error.message || this.data.ui.error; this.status.setAttribute('data-error',''); }
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.update();
      }
    }
  }
  customElements.define('ss-polish-set',SSPolishSet);
})();

